module.exports = __webpack_public_path__ + "static/media/eight-flowers.1d784d9e.jpg";